import React from 'react';
import { Dialog } from '@mui/material';
import AddEventForm from './AddEvent';

const EventToggleModal = ({open,editEventId,toggle}) => {
  const handleClose = (event: object, reason: string) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      return;
    }
    toggle();
  };

  return (
    <Dialog
      open={open}
      keepMounted
      maxWidth="lg"
      fullWidth
      scroll="paper"
      onClose={handleClose}
    >
      <AddEventForm open={open} toggle={toggle} editEventId={editEventId}/>
    </Dialog>
  );
};

export default EventToggleModal;
